module.exports = __webpack_public_path__ + "static/media/papeleria.41a7a2bd.svg";